:host {
  display: block;
}

.pills-wrapper {
  display: flex;
  gap: var(--spacing-comp-02);
  flex-wrap: wrap;
}

/*********************************************
Mercury
**********************************************/
:host(.mercury) .pills-wrapper {
  gap: var(--spacing-comp-04);
}